import {configureStore} from '@reduxjs/toolkit';
import applicationProcessReducer from './slices/application-process.slice';

const store = configureStore({
    reducer: {
        applicationProcess: applicationProcessReducer,
    },
});

export default store;